export default __webpack_public_path__ + "static/media/trincheta-menu-logo-transparent.5f3361d4.png";